import Vue from 'vue';
import takeoutDialog from './takeoutDialog';
import businessDialog from './checkBusinessDialog';

const takeout = Vue.extend(takeoutDialog);
const checkBusiness = Vue.extend(businessDialog);

let instance;

const open = function (option, _callback) {
    if (!instance) {
        if (!option.isBusiness) {//打烊了
            instance = new checkBusiness({
                el: document.createElement('div')
            });
        } else {
            instance = new takeout({
                el: document.createElement('div')
            });
        }
    }
    instance.bnText = option.bnText||"开始点菜";
    instance.storeInfo.city = option.city;
    instance.storeInfo.name = option.name;
    instance.storeInfo.address = option.address;
    instance.storeInfo.houseNo = option.houseNo;
    instance.storeInfo.tel = option.telephone;
    instance.storeInfo.gdLat = option.gdlat;
    instance.storeInfo.gdLng = option.gdlng;
    instance.storeInfo.sendDistance = option.sendDistance;
    instance.storeInfo.businessTime = option.businessTime;
    instance.storeInfo.businessTimeText = option.businessTime[0].startTime + "-" + option.businessTime[0].endTime;
    instance.storeInfo.openReservation = option.openReservation;
    instance.call = _callback;
    if (instance.visible) return;

    document.body.appendChild(instance.$el);
    Vue.nextTick(() => {
        instance.visible = true;
    });
};

const close = function () {
  if(instance){
    instance.visible = false;
  }
};

export default {
  open,
  close
}



// WEBPACK FOOTER //
// ./src/components/takeoutDialog/index.js